import React from "react";
import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import EventsDataTable from "../components/EventsDataTable";

const EventsPage = () => (
  <MasterLayout>
    <DefaultTopBar
      title="Events"
      desc="View and manage all upcoming and completed events."
    />
    <EventsDataTable />
  </MasterLayout>
);

export default EventsPage;
